import Head from 'next/head';
import { Box, Container, Typography } from '@mui/material';
import { DashboardLayout } from '../dashboard-layout';

import 'firebase/compat/firestore';

import LocationCard from './LocationCard';
import { useParams } from 'react-router-dom';

const EditLocation = () => {
  const { id } = useParams();
  return (
    <>
      <Head>
        <title>
          Modifier boutique
        </title>
      </Head>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 3
        }}
      >
        <Container maxWidth="md">
          <Typography
            sx={{ mb: 3 }}
            variant="h4"
          >
            Modifier les paramètres de la boutique
          </Typography>
          <LocationCard locationId={id} isUpdate={true}/>
          {/* <Box sx={{ mt: 3 }}>
            <OrdersFullPanel />
          </Box> */}
        </Container>
      </Box>
    </>
  );
}

EditLocation.getLayout = (page) => (
  <DashboardLayout>
    {page}
  </DashboardLayout>
);

export default EditLocation;
